import { UserStatus } from './representative.model';

export enum SystemUserRole {
  'insurer' = 'Insurer',
  'client' = 'Client',
  'admin' = 'Admin',
  'PartnerRepresentative' = 'PartnerRepresentative',
  'AdminPartnerRepresentative' = 'AdminPartnerRepresentative',
  'AdminAgentRepresentative' = 'AdminAgentRepresentative',
  'InsurerRepresentative' = 'InsurerRepresentative',
  'AgentRepresentative' = 'AgentRepresentative',
  'BrokerRepresentative' = 'BrokerRepresentative',
}

export interface IDeactivateUserResponse {
  message: string;
  status: boolean;
}

export interface IDeactivateUserQueryParams {
  id: number;
  status: IAction;
}

export enum UserRole {
  salesRepresentative = 'SalesRepresentative',
  salesManager = 'SalesManager',
  administrator = 'Administrator',
}

export const userRoles: UserRole[] = [
  UserRole.administrator,
  UserRole.salesRepresentative,
  UserRole.salesManager,
];

export type IAction = 'Active' | 'Activate' | 'Suspended' | 'Deactivate';

export interface IUserStatusBulkRequest{
  status: UserStatus;
  userIds: number[];
}
export interface IUserStatusBulkResponse{
  message: string;
}
